import { mapAffectedTotalsToStateUpdates, updateTotalValue } from '../gridReport/storeHelpers';

export const getUpdateEditedCellAction = reportName => {
  const reportUpdateEditedCellActionType = `UPDATE_EDITED_CELL_FOR_GROUP_${reportName.toUpperCase()}`;

  const updateEditedCellForGroup = ({ oldValue: newValue, data }) => {
    const { data: values, key, affectedTotals } = newValue;
    const { value, ...extraValues } = values;
    return {
      type: reportUpdateEditedCellActionType,
      value,
      key,
      taxYearForEditableChecks: data.taxYearForEditableChecks,
      entryType: data.TAX_ENTRY_TYPE,
      affectedTotals,
      extraValues,
    };
  };

  return {
    reportUpdateEditedCellActionType,
    updateEditedCellForGroup,
  };
};

export const getRevertEditedCellsAction = reportName => {
  const revertEditedCellsForGroupActionType = `REVERT_EDITED_CELLS_${reportName.toUpperCase()}`;

  const revertEditedCellsForGroup = () => ({
    type: revertEditedCellsForGroupActionType,
  });

  return {
    revertEditedCellsForGroupActionType,
    revertEditedCellsForGroup,
  };
};

const updateEditedRow = (
  rows,
  { key, taxYearForEditableChecks, entryType, value, affectedTotals, extraValues = {} }
) => rows.map(row => {
  if (row.taxYearForEditableChecks.toLowerCase() === 'total' && row.TAX_ENTRY_TYPE === entryType) {
    const rowWithEditedValue = rows.find(
      r => r.taxYearForEditableChecks === taxYearForEditableChecks && r.TAX_ENTRY_TYPE === entryType
    );
    const previousCellValue = rowWithEditedValue[key].value;
    const totalUpdates = mapAffectedTotalsToStateUpdates(affectedTotals, row, previousCellValue, value);

    return {
      ...row,
      [key]: updateTotalValue(row, previousCellValue, value, key),
      ...totalUpdates,
    };
  }

  if (row.taxYearForEditableChecks !== taxYearForEditableChecks || row.TAX_ENTRY_TYPE !== entryType) {
    return row;
  }

  const previousCellValue = row[key].value;
  const totalUpdates = mapAffectedTotalsToStateUpdates(affectedTotals, row, previousCellValue, value);

  return {
    ...row,
    [key]: {
      ...row[key],
      ...extraValues,
      value,
      edited: true,
      unapprovedFlag: true,
    },
    ...totalUpdates,
  };
});

export const updateEditedRows = (state, payload) => {
  const originalReportRows = !state.originalReportRows
    ? { originalReportRows: [...state.reportData.rows] }
    : {};

  return {
    ...state,
    ...originalReportRows,
    reportData: {
      ...state.reportData,
      rows: updateEditedRow(
        state.reportData.rows,
        payload
      ),
    },
  };
};

export const revertEditedCells = state => ({
  ...state,
  reportData: {
    ...state.reportData,
    rows: [
      ...state.originalReportRows,
    ],
  },
});
